import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  Snackbar,
  Divider,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Layout } from '../components/layout/Layout';
import { aiAssistantService } from '../services/aiAssistantService';

export const Configuracion: React.FC = () => {
  const [apiKey, setApiKey] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    const savedKey = localStorage.getItem('gemini_api_key');
    if (savedKey) {
      setApiKey(savedKey);
    }
  }, []);

  const handleSave = () => {
    localStorage.setItem('gemini_api_key', apiKey);
    aiAssistantService.initialize();
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <Layout>
      <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, px: 2 }}>
        <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 2, fontWeight: 'bold', color: 'primary.main' }}>
          <SmartToyIcon fontSize="large" />
          Configuración de Asistente IA
        </Typography>
        
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            API Key de Gemini
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Para utilizar las funcionalidades del Asistente de IA, necesitas proporcionar una clave de API de Google Gemini (modelo Gemini 3 Flash Preview). 
            Puedes obtenerla desde <a href="https://aistudio.google.com/app/apikey" target="_blank" rel="noopener noreferrer">Google AI Studio</a>.
            Esta clave se guardará localmente en tu navegador.
          </Typography>

          <TextField
            fullWidth
            label="Google Gemini API Key"
            variant="outlined"
            type="password"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            sx={{ mb: 3 }}
            placeholder="AIzaSy..."
          />

          <Divider sx={{ mb: 3 }} />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handleSave}
              disabled={!apiKey.trim()}
            >
              Guardar Configuración
            </Button>
          </Box>
        </Paper>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
            Configuración guardada correctamente
          </Alert>
        </Snackbar>
      </Box>
    </Layout>
  );
};

export default Configuracion;
